import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CustomUserCrudLayer from "../components/CustomUserCrudLayer";
import MasterLayout from "../masterLayout/MasterLayout";

const CustomUsersPage = () => (
  <MasterLayout>
    <Breadcrumb title="Custom User" />
    <CustomUserCrudLayer />
  </MasterLayout>
);

export default CustomUsersPage;
